var AlgoliaAnalyticsEvents = /* @__PURE__ */ ((AlgoliaAnalyticsEvents2) => {
  AlgoliaAnalyticsEvents2["SearchSuggestionClicked"] = "Search Suggestion Clicked";
  AlgoliaAnalyticsEvents2["SearchResultClicked"] = "Search Result Clicked";
  AlgoliaAnalyticsEvents2["ProductDetailCTAClicked"] = "Product Detail CTA Clicked";
  AlgoliaAnalyticsEvents2["FilterApplied"] = "Filter Applied";
  AlgoliaAnalyticsEvents2["ProductsViewed"] = "Products Viewed";
  return AlgoliaAnalyticsEvents2;
})(AlgoliaAnalyticsEvents || {});
var AlgoliaEventType = /* @__PURE__ */ ((AlgoliaEventType2) => {
  AlgoliaEventType2["Conversion"] = "convertedObjectIDs";
  AlgoliaEventType2["ConversionAfterSearch"] = "convertedObjectIDsAfterSearch";
  AlgoliaEventType2["Click"] = "clickedObjectIDs";
  AlgoliaEventType2["ClickAfterSearch"] = "clickedObjectIDsAfterSearch";
  return AlgoliaEventType2;
})(AlgoliaEventType || {});
export {
  AlgoliaAnalyticsEvents,
  AlgoliaEventType
};
//# sourceMappingURL=types.js.map
